import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Layout2 from "../layouts/Layout2";
import Swal from "sweetalert2";
import '../App.css';

const Currency = () => {
    const [data,setData] = useState([]);
    const [date,setDate] = useState("");
    const [isLoading,setIsLoading] = useState(false);
    const endpointURL =process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;
    const handleFetch = async (e) => {
        try{
            const response = await fetch(endpointURL+'/api/v1/exchange-rate',{
                headers: { 
                    'Content-Type': 'application/json'
                  }
              });
              const result = await response.json(); 
              if(result.status === true)
              {
                setData(result.data);
                setDate(result.date);
                setIsLoading(false);
              }
        }catch(error){
            Swal.fire({
                title: error.message,
                width: 450,
              });
        }
    }
    useEffect(()=>{
        setIsLoading(true);
        handleFetch();
    },[])
    return ( 
        <Layout2 pageType="ငွေလဲလှယ်နှုန်းများ">
                <Helmet>
                    <title>ငွေလဲလှယ်နှုန်းများ</title>
                </Helmet>
                <div className="currency-container">
                    <div className="currency-header">
                        <h6>📊 {date} ရက်နေ့ ငွေလဲလှယ်နှုန်းများ</h6>
                    </div>
                    {
                        isLoading ? 
                            <div className="currency-loading">
                                <Spinner animation="border" role="status" className="currency-loading-spinner">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p>လုပ်ဆောင်နေသည်...ခဏစောင့်ပါ</p>
                            </div>
                        :
                        data.length > 0 ? 
                            <div className="currency-list">
                                {data.map((list,index)=>(
                                        <div key={index} className="currency-card">
                                            <div className="currency-card-header">
                                                <h6 className="currency-name">{list.name}</h6>
                                                <i className="lni lni-money-protection currency-icon"></i>
                                            </div>
                                            <div className="currency-details">
                                                <span className="currency-type">
                                                    {list.exchange_rate_type_id == 2 || list.exchange_rate_type_id == 8 ? list.to+" အထိ" : ""}
                                                </span>
                                                <span className="currency-price">ဈေးနှုန်း {list.price}</span>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        :
                        <div className="currency-empty">
                            <p>ဒေတာမရှိပါ</p>
                        </div>
                    }
                </div>
            </Layout2>
     );
}
 
export default Currency;